export default __webpack_public_path__ + "static/media/empty-analysis.54a189d7.svg";